const map = {
	"./arrow-down-blue.svg": 4220,
	"./arrow-down-grey.svg": 713,
	"./arrow-right-white.png": 6997,
	"./arrow-right.svg": 7095,
	"./blue-loader.svg": 2517,
	"./circle-grey.svg": 9833,
	"./circle.svg": 6839,
	"./coinbaseWalletIcon.svg": 6919,
	"./dropdown-blue.svg": 7013,
	"./dropdown.svg": 4156,
	"./dropup-blue.svg": 3116,
	"./ethereum-logo.png": 5706,
	"./fortmaticIcon.png": 1223,
	"./link.svg": 5735,
	"./magnifying-glass.svg": 3283,
	"./menu.svg": 4618,
	"./metamask.png": 3168,
	"./plus-blue.svg": 4352,
	"./plus-grey.svg": 4389,
	"./portisIcon.png": 5761,
	"./question-mark.svg": 7463,
	"./question.svg": 5275,
	"./spinner.svg": 3126,
	"./trustWallet.png": 2282,
	"./walletConnectIcon.svg": 5177,
	"./x.svg": 1345
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;